import type { TranslationKey } from './en.js';

export const ja: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'チャット',
  'section.image': '画像',
  'section.video': '動画',
  'section.video2': '動画 2 (Marketing Studio)',
  'section.character': 'キャラクター',
  'section.audio': '音楽とオーディオ',
  'section.voice': '音声',
  'section.design': 'デザイン',

  'common.loading': '読み込み中…',
  'common.error': '問題が発生しました',
  'common.retry': '再試行',
  'common.refresh': '更新',
  'common.cancel': 'キャンセル',
  'common.confirm': '確認',
  'common.save': '保存',
  'common.close': '閉じる',
  'common.delete': '削除',
  'common.create': '作成',
  'common.apply': '適用',
  'common.offline': 'オフライン — キャッシュを表示中',
  'common.you': 'あなた',
  'common.assistant': 'アシスタント',
  'common.empty': 'まだ何もありません',
  'common.back': '戻る',

  'auth.loading': 'サインイン中…',
  'auth.openInTelegram': 'Telegram で開いてください',
  'auth.openInTelegramHint':
    'Volt は Telegram ミニアプリです。ボットとのチャットから起動してサインインしてください。',
  'auth.retry': '再試行',
  'auth.error': 'サインインできませんでした',
  'auth.devHint': '開発プレビュー — Telegram データなし。',

  'topbar.menu': 'メニューを開く',
  'topbar.settings': '設定',
  'topbar.balance': '残高',

  'directChat.open': '個人チャットを開く',
  'pager.chat': 'チャット',
  'pager.label': 'ページ切り替え',
  'directChat.title': '個人チャット',
  'directChat.yourId': 'あなたの ID: {id}',
  'directChat.addPlaceholder': '公開 ID または Telegram の @username',
  'directChat.addFriend': '友達を追加',
  'directChat.addSelf': '自分自身を友達に追加することはできません。',
  'directChat.friends': '友達',
  'directChat.noFriends':
    '友達はいません。公開 ID または Telegram の @username で追加してください。',
  'directChat.selectFriend': '友達を選択して会話を開いてください。',
  'directChat.noMessages': 'メッセージはありません。挨拶を送ってみましょう！',
  'directChat.messagePlaceholder': 'メッセージを入力…',
  'directChat.send': 'メッセージを送信',
  'directChat.notFound': 'この ID または Telegram ユーザー名のユーザーが見つかりません。',
  'directChat.noPermission': '友達にのみメッセージを送信できます。',
  'directChat.addError': 'ID またはユーザー名を確認してください。追加済みの可能性があります。',
  'directChat.error': 'チャットを読み込めませんでした。もう一度お試しください。',
  'directChat.openDrawer': '会話一覧を開く',
  'directChat.chats': '会話',
  'directChat.groups': 'グループ',
  'directChat.newGroup': '新しいグループ',
  'directChat.createGroup': 'グループを作成',
  'directChat.groupName': 'グループ名',
  'directChat.selectMembers': 'メンバーを選択（自分を含め{count}/50）',
  'directChat.memberCount': '{count}人のメンバー',
  'directChat.messages': 'メッセージ',
  'directChat.messageActions': 'メッセージの操作',
  'directChat.reply': '返信',
  'directChat.replyingTo': '{name}に返信',
  'directChat.forward': '転送',
  'directChat.forwarded': '転送済み',
  'directChat.chooseDestination': '転送先の会話を選択',
  'directChat.deleteForMe': '自分の画面から削除',
  'directChat.deleteForEveryone': '全員から削除',
  'directChat.deleteForEveryoneConfirm': 'チャットの全員からこのメッセージを削除しますか？',
  'directChat.aiAttribution': '人工知能',
  'directChat.aiToggleEnabled': 'AI返信が有効です',
  'directChat.aiToggleDisabled': 'AI返信が無効です',
  'directChat.aiGenerating': 'AIが返信中…',
  'directChat.aiGenerationError': 'AI返信の生成に失敗しました: {error}',
  'directChat.aiChooseModel': 'AIモデルを選択',
  'directChat.aiLongPressHint': '長押しでモデルを選択',
  'directChat.sent': '送信済み',
  'directChat.delivered': '配信済み',
  'directChat.read': '既読',

  'sidebar.title': 'チャット',
  'sidebar.newChat': '新しいチャット',
  'sidebar.search': '検索',
  'sidebar.searchPlaceholder': 'チャットを検索…',
  'sidebar.projects': 'プロジェクト',
  'sidebar.newProject': '新しいプロジェクト',
  'sidebar.noConversations': 'まだ会話がありません',
  'sidebar.archived': 'アーカイブ',
  'sidebar.showArchived': 'アーカイブを表示',
  'sidebar.hideArchived': 'アーカイブを隠す',
  'sidebar.pinned': 'ピン留め',
  'sidebar.today': '今日',
  'sidebar.yesterday': '昨日',
  'sidebar.previous7Days': '過去 7 日間',
  'sidebar.previous30Days': '過去 30 日間',
  'sidebar.older': 'それ以前',

  'menu.rename': '名前を変更',
  'menu.pin': 'ピン留め',
  'menu.unpin': 'ピン留めを解除',
  'menu.archive': 'アーカイブ',
  'menu.unarchive': 'アーカイブ解除',
  'menu.addToFolder': 'フォルダに追加',
  'menu.moveUp': '上に移動',
  'menu.moveDown': '下に移動',
  'menu.delete': '削除',
  'menu.deleteTitle': 'チャットを削除しますか？',
  'menu.deleteConfirm': 'この会話とメッセージは完全に削除されます。',

  'project.name': 'プロジェクト名',
  'project.description': '説明',
  'project.systemPrompt': 'カスタム指示',
  'project.systemPromptHint': 'この指示はプロジェクト内の各チャットでモデルに送信されます。',
  'project.create': 'プロジェクトを作成',
  'project.empty': 'まだプロジェクトがありません',

  'composer.placeholder': 'Volt にメッセージ…',
  'composer.imagePlaceholder': '欲しい画像を説明…',
  'composer.videoPlaceholder': '欲しい動画を説明…',
  'composer.characterPlaceholder': 'キャラクターを説明…',
  'composer.audioPlaceholder': '音楽やオーディオを説明…',
  'composer.voicePlaceholder': '音声にするテキスト…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'キャラクター',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'AIインフルエンサー',
  'character.soulIdTitle': 'Soul ID を学習',
  'character.characterTitle': 'キャラクター',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'AIインフルエンサー',
  'character.name': '名前',
  'character.description': '説明',
  'character.bio': 'プロフィール',
  'character.style': 'スタイル',
  'character.scene': 'シーン',
  'character.prompt': 'プロンプト',
  'character.referenceImages': '参照画像URL（1行に1つ）',
  'character.pickSoulId': 'Soul ID を選択',
  'character.pickCharacter': 'キャラクターを選択',
  'character.noSoulLinked': '関連付けられた Soul ID なし',
  'character.scopeLabel': '作成するもの',
  'character.scopeHead': '頭部',
  'character.scopeFullBody': '全身',
  'character.scopeHeadHint': 'さまざまな角度の顔のクローズアップが最適です。',
  'character.scopeFullBodyHint': '全身を作るには、全身が写った写真を追加してください。',
  'character.scopeBadgeHead': '頭部',
  'character.scopeBadgeFullBody': '全身',
  'character.model3dCreate': '3Dモデルを作成',
  'character.model3dView': '3Dで見る',
  'character.model3dBuilding': '3Dモデルを作成中… 数分かかります。',
  'character.model3dFailed': '3Dモデルを作成できませんでした',
  'character.model3dRetry': '再試行',
  'character.model3dStarted': '3Dモデルを作成しています',
  'character.model3dStage': '3Dモデルビューア',
  'character.model3dLoading': 'モデルを読み込み中…',
  'character.model3dError': '3Dモデルを開けませんでした。',
  'character.model3dUnsupported': 'お使いのデバイスは3D（WebGL）に対応していません。',
  'character.model3dHint': 'ドラッグで回転 · ピンチまたはホイールで拡大縮小',
  'character.model3dReset': '表示をリセット',
  'character.model3dAutoRotate': '自動回転',
  'character.soulIdPhotoHint': '5〜20枚の参照写真をアップロードしてください。',
  'character.soulIdPhotoCount': '5〜20枚の写真を選択してください。',
  'character.soulIdUploadFailed': '写真をアップロードできませんでした。もう一度お試しください。',
  'character.createSoulId': 'Soul ID を作成',
  'character.createCharacter': 'キャラクターを作成',
  'character.createAiInfluencer': 'AIインフルエンサーを作成',
  'character.generateSoulCast': 'Soul Cast を生成',
  'character.generateContent': 'コンテンツを生成',
  'character.status.training': '学習中',
  'character.status.ready': '準備完了',
  'character.status.failed': '失敗',
  'composer.send': '送信',
  'composer.stop': '停止',
  'composer.attach': 'ファイルを添付',
  'composer.attachTitle': '添付を追加',
  'composer.attachAllPhotos': 'すべての写真',
  'composer.attachCamera': 'カメラ',
  'composer.attachPhotos': '写真',
  'composer.attachFiles': 'ファイル',
  'composer.attachFilesHint': '写真を圧縮せずに',
  'composer.attachToFolder': 'フォルダーに追加',
  'composer.voiceInput': '音声入力',
  'composer.listening': '聞き取り中…',
  'composer.thinking': '考え中…',
  'composer.model': 'モデル',
  'composer.selectModel': 'モデルを選択',
  'composer.unavailable': '利用不可',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': '続けるには残高を {amount} までチャージしてください',
  'composer.generate': '生成',

  'message.copy': 'コピー',
  'message.copied': 'コピーしました',
  'message.share': '共有',
  'message.regenerate': '再生成',
  'message.edit': '編集',
  'message.save': '保存して再送信',
  'message.up': '良い回答',
  'message.down': '悪い回答',
  'message.usage': '{model} · 入力 {input} · 出力 {output} · {cost}',
  'message.usageNoModel': '入力 {input} · 出力 {output} · {cost}',
  'message.failed': '生成に失敗しました',
  'message.reasoningTitle': '処理の経過',
  'conversation.pinnedBadge': '固定されたチャット',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'チャットに送信',
  'share.noDestinations': '利用可能なチャットやグループがありません',
  'share.sentSuccess': '送信しました！',
  'share.sending': '送信中…',
  'share.loadingDestinations': 'チャットを読み込み中…',
  'artifact.preview': 'プレビュー',
  'artifact.code': 'コード',
  'artifact.open': 'アーティファクトを開く',
  'artifact.export': 'エクスポート',
  'artifact.download': 'ダウンロード',
  'artifact.copy': 'コピー',
  'artifact.edit': '編集',
  'artifact.close': '閉じる',
  'artifact.fullscreen': '全画面',

  'job.status': '状態',
  'job.pending': '待機中',
  'job.processing': '処理中…',
  'job.done': '完了',
  'job.failed': '失敗',
  'job.cancelled': 'キャンセル済み',
  'job.result': '結果',
  'job.empty': 'まだ生成がありません',
  'job.actions': '操作',
  'job.favoriteAdd': 'お気に入りに追加',
  'job.favoriteRemove': 'お気に入りから削除',
  'job.favorited': 'お気に入り',
  'job.regenerate': '再生成',
  'job.viewPrompt': 'プロンプトを表示',
  'job.promptTitle': 'プロンプト',
  'job.download': 'ダウンロード',
  'job.deleteTitle': 'この生成を削除しますか?',
  'job.deleteConfirm': 'この生成は完全に削除されます。',

  'design.subtitle': 'デザインツールを新しいウィンドウで開く',
  'design.open': '開く',

  'settings.title': '設定',
  'settings.profile': 'プロフィール',
  'settings.appearance': '外観',
  'settings.theme': 'テーマ',
  'settings.themeLight': 'ライト',
  'settings.themeDark': 'ダーク',
  'settings.themeSystem': 'システム',
  'settings.language': '言語',
  'settings.balance': '残高',
  'settings.topup': 'チャージ',
  'settings.topupAmount': '金額, ₽',
  'settings.topupSubmit': '残高をチャージ',
  'settings.transactions': '取引履歴',
  'settings.noTransactions': 'まだ取引がありません',
  'settings.loadMore': 'もっと読み込む',
  'settings.notifications': '通知',
  'settings.notificationsHint': '生成が完了したら通知する',
  'settings.data': 'あなたのデータ',
  'settings.exportData': 'データをエクスポート',
  'settings.deleteAccount': 'アカウントを削除',
  'settings.deleteAccountTitle': 'アカウントを削除しますか？',
  'settings.deleteAccountConfirm': 'アカウント、会話、残高が完全に削除されます。元に戻せません。',
  'settings.username': 'ユーザー名',
  'settings.name': '名前',

  'admin.title': '管理',
  'admin.stats': '統計',
  'admin.users': 'ユーザー',
  'admin.settings': 'プラットフォーム設定',
  'admin.markup': 'マークアップ, %',
  'admin.usdRub': 'USD → RUB レート',
  'admin.minBalance': '最低残高, ₽',
  'admin.contextLimit': 'コンテキスト件数',
  'admin.models': 'モデル価格',
  'admin.price': '価格',
  'admin.revenue': '売上',
  'admin.cost': 'プロバイダー費用',
  'admin.margin': '利益',
  'admin.activeUsers': 'アクティブ (24h)',
  'admin.failedJobs': '失敗ジョブ',
  'admin.ban': 'ブロック',
  'admin.unban': 'ブロック解除',
  'admin.adjustBalance': '残高を調整',
  'admin.reason': '理由',
  'admin.amount': '金額, ₽',
  'admin.errorHistory': 'エラー履歴',
  'admin.errorsEmpty': 'まだエラーは記録されていません。',

  'error.UNAUTHORIZED': 'セッションが切れました。アプリを開き直してください。',
  'error.FORBIDDEN': 'アクセス権がありません。',
  'error.USER_BANNED': 'アカウントが停止されています。',
  'error.NOT_FOUND': '見つかりません。',
  'error.RATE_LIMITED': 'リクエストが多すぎます。少し待ってください。',
  'error.DAILY_LIMIT_EXCEEDED': '1 日の上限に達しました。明日お試しください。',
  'error.INSUFFICIENT_BALANCE': 'このリクエストには残高が不足しています。',
  'error.BELOW_MIN_BALANCE': '残高が最低額を下回っています。',
  'error.MODEL_UNAVAILABLE': 'このモデルは現在利用できません。',
  'error.MODEL_NOT_SUPPORTED': 'このモデルはここではサポートされていません。',
  'error.PROVIDER_ERROR': 'プロバイダーがエラーを返しました。',
  'error.PROVIDER_TIMEOUT': 'プロバイダーがタイムアウトしました。',
  'error.CONTEXT_TOO_LARGE': 'この会話はモデルには長すぎます。',
  'error.PAYMENT_INVALID': '支払いを処理できませんでした。',
  'error.INTERNAL': 'サーバーエラー。もう一度お試しください。',
  'error.network': 'ネットワークエラー。接続を確認してください。',
  'error.streamInterrupted': '接続が中断されました。サーバーから返答を復元しました。',
  'error.generic': '問題が発生しました。',
};
